import config from '../../../config';
import {authFetch, checkStatus, parseHeadersAndJson} from '../../utils/http';

export default class LiveDocumentReminderService {
  getDocumentRemindersBySubcontractor(subcontractorId, organisationId, page = 0, size = 10) {
    return authFetch(`${config.documentApi}/api/v1/document-reminders?subcontractorId=${subcontractorId}&organisationId=${organisationId}&page=${page}&size=${size}`)
      .then(checkStatus)
      .then(parseHeadersAndJson)
      .then(({json, headers}) => ({
        reminders: json,
        totalCount: Number(headers.get('X-Total-Count'))
      }));
  }

  getDocumentsByReminder(reminderId, subcontractorId, organisationId, signal) {
    return authFetch(`${config.documentApi}/api/v1/document-reminders/${reminderId}?subcontractorId=${subcontractorId}&organisationId=${organisationId}`, {signal})
      .then(checkStatus)
      .then(response => response.json());
  }
}
